export const allowedDocumentFileExtensions = [
  "pdf",
  "jpg",
  "jpeg",
  "png",
] as const;
export const allowedDocumentFileTypes = [
  "application/pdf",
  "image/jpeg",
  "image/png",
] as const;
export const imageExtensions = [".jpg", ".jpeg", ".png"] as const;
export const imageTypes = ["image/jpeg", "image/png"] as const;

// File upload size limits
export const MAX_UPLOAD_SIZE_MB = 10;
export const MAX_UPLOAD_SIZE = MAX_UPLOAD_SIZE_MB * 1024 * 1024; // 10MB in bytes

// Feature flags
// Ticketing (My Tickets menu, Book Now button, Stripe Connect switch) is
// hidden from UI per client request until ticketing feature is needed.
export const TICKETING_ENABLED = false;

// External platform export (Facebook/LinkedIn Connected Platforms section in
// OrganizationForm, Platforms step in event creation wizard) hidden per
// client request.
export const EXTERNAL_PLATFORMS_ENABLED = false;
